module.exports = __webpack_public_path__ + "dba2a8c87ef2220559e68a1a9329a41f.svg";